import { ErrorLogType, ErrorLogLevel } from '@app/models/log/error';

export const ERROR_LOG_TYPE_LABELS: Record<ErrorLogType, string> = {
  [ErrorLogType.SYSTEM_ERROR]: 'System Error',
  [ErrorLogType.VALIDATION_ERROR]: 'Validation Error',
  [ErrorLogType.INTEGRATION_ERROR]: 'Integration Error',
  [ErrorLogType.AUTHENTICATION_ERROR]: 'Authentication Error',
  [ErrorLogType.AUTHORIZATION_ERROR]: 'Authorization Error',
  [ErrorLogType.NETWORK_ERROR]: 'Network Error',
  [ErrorLogType.DATABASE_ERROR]: 'Database Error',
  [ErrorLogType.BUSINESS_LOGIC_ERROR]: 'Business Logic Error',
  [ErrorLogType.QUEUE_ERROR]: 'Queue Error',
};

export const ERROR_LOG_LEVEL_LABELS: Record<ErrorLogLevel, string> = {
  [ErrorLogLevel.LOW]: 'Low',
  [ErrorLogLevel.MEDIUM]: 'Medium',
  [ErrorLogLevel.HIGH]: 'High',
  [ErrorLogLevel.CRITICAL]: 'Critical',
};

export const ERROR_LOG_TYPE_OPTIONS = Object.values(ErrorLogType).map(
  (value) => ({
    value,
    label: ERROR_LOG_TYPE_LABELS[value as ErrorLogType],
  })
);

export const ERROR_LOG_LEVEL_OPTIONS = Object.values(ErrorLogLevel).map(
  (value) => ({
    value,
    label: ERROR_LOG_LEVEL_LABELS[value as ErrorLogLevel],
  })
);

export const getErrorLogTypeColor = (type: ErrorLogType): string => {
  switch (type) {
    case ErrorLogType.SYSTEM_ERROR:
      return 'bg-red-100 text-red-800';
    case ErrorLogType.VALIDATION_ERROR:
      return 'bg-yellow-100 text-yellow-800';
    case ErrorLogType.INTEGRATION_ERROR:
      return 'bg-orange-100 text-orange-800';
    case ErrorLogType.AUTHENTICATION_ERROR:
      return 'bg-purple-100 text-purple-800';
    case ErrorLogType.AUTHORIZATION_ERROR:
      return 'bg-pink-100 text-pink-800';
    case ErrorLogType.NETWORK_ERROR:
      return 'bg-blue-100 text-blue-800';
    case ErrorLogType.DATABASE_ERROR:
      return 'bg-indigo-100 text-indigo-800';
    case ErrorLogType.BUSINESS_LOGIC_ERROR:
      return 'bg-gray-100 text-gray-800';
    case ErrorLogType.QUEUE_ERROR:
      return 'bg-system-warning text-yellow-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getErrorLogLevelColor = (level: ErrorLogLevel): string => {
  switch (level) {
    case ErrorLogLevel.LOW:
      return 'bg-green-100 text-green-800';
    case ErrorLogLevel.MEDIUM:
      return 'bg-yellow-100 text-yellow-800';
    case ErrorLogLevel.HIGH:
      return 'bg-orange-100 text-orange-800';
    case ErrorLogLevel.CRITICAL:
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
